var _defs, _rect, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _rect2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300.89 444.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f04e23;}.cls-3{fill:#fff;}.cls-4{fill:#812990;}.cls-5{fill:#6b7b84;}.cls-6,.cls-9{fill:#231f20;}.cls-7,.cls-8{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-7{stroke:#ffcb05;}.cls-8{stroke:#6b7b84;}.cls-9{font-size:8px;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-10{letter-spacing:-0.04em;}.cls-11{letter-spacing:-0.06em;}.cls-12{letter-spacing:0em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.13,
    y1: 212.72,
    x2: 300.77,
    y2: 212.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.13,
    y: 0.12,
    width: 300.64,
    height: 425.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "272.14 425.23 229.19 353.65 186.24 425.23 272.14 425.23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "272.14 425.23 246.39 382.33 300.77 382.33 300.77 425.32 222.95 425.32 223.01 425.23 272.14 425.23"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.13 353.74 229.19 353.74 186.24 425.32 0.13 425.32 0.13 353.74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.71,403.45l-.81.12a3.47,3.47,0,0,1-.4.08c-.32,0-.48-.39-.91-.48-.11,0,0,0-.17-.05s.06,0-.2-.1c0,.29-.06.21-.06.43a1.62,1.62,0,0,0,.18.74c.08.16.11.1.1.34a1.42,1.42,0,0,0,.13.92,2.51,2.51,0,0,1,.32.66c.43,0,.36,0,.42.12.4,0,.14-.09.36-.12,0,0,.41.1.31-.42.3.08.16.24.35.22s.08-.15.11-.33-.08-.06.21-.19l-.07-.37c0-.42.1,0,.24.07l.18-1.28c0-.1.14-.06-.11-.42C72.61,403.42,72.77,403.43,72.71,403.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.82,402.36c0,.17.1.1-.11.12L73,403c.11,0,.07,0,.24,0,0-.37,0-.24-.12-.43S73,402.4,72.82,402.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.79,401.88c-.06.24,0,0-.08.19s-.11.54.26.35C70,402,70,402,69.79,401.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.12,397.58a2.11,2.11,0,0,0-.75.12c-.44.11-.25.21-.1.42a2.7,2.7,0,0,0,1-.15c.2,0,.21,0,.1-.21h-.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.4,394.6a1.17,1.17,0,0,0-.05-.2l-.7-.26-1.46-.56c-.43-.17-1-.4-1.55-.68s-1.18-.59-1.79-1a4.15,4.15,0,0,1-1.47-1.67,5.24,5.24,0,0,1-.33-.84h-.12a3.26,3.26,0,0,0-.67.09l-.62.16a8.26,8.26,0,0,1-1.7.32h-.22c-.21,0-.43,0-.64,0a3.53,3.53,0,0,1-.48,0,10.29,10.29,0,0,1-1-.18l-.35-.08-.28.33a.75.75,0,0,1,.19.17,1.24,1.24,0,0,1,.25,1.19,1.83,1.83,0,0,1-1.58,1.16l-.58,0h-.1a1.92,1.92,0,0,1-1.56-1,1.39,1.39,0,0,1,.11-1.52l0-.05.25-.37a4.18,4.18,0,0,0,.29-.45l.15-.32a2.07,2.07,0,0,1-1.74-1.32,4.14,4.14,0,0,1-.27-1.26l-.18,0-.28.07a2.27,2.27,0,0,1-.24.27,1.53,1.53,0,0,1-1.08.5,1.23,1.23,0,0,1-.42-.07h-.07a1.36,1.36,0,0,1-.81-.25,1.07,1.07,0,0,1-.45-.31,1.06,1.06,0,0,1-.21-.91,3.86,3.86,0,0,1,.7-1.5l.08-.12a1.46,1.46,0,0,1,.42-.86c.19-.18.37-.34.56-.49l.14-.13.31-.23a1.76,1.76,0,0,1,.29-.81,3.2,3.2,0,0,1,1-1c.21-.14.42-.25.62-.36l.3-.18.29-.17.16-.1a.89.89,0,0,1,.87-.05,1,1,0,0,1,.52,1.1s-.23.8-.31,1.06a2.27,2.27,0,0,1-.44.84,6.79,6.79,0,0,1,.65.44,4.13,4.13,0,0,1,.52.49h.39l.14,0a3.53,3.53,0,0,0,1-.44L64,383a8.25,8.25,0,0,1,1.89-.9,13,13,0,0,1,3.36-.48h.44c.62,0,1.24,0,1.82.06a12.62,12.62,0,0,1,1.39.19,8.08,8.08,0,0,1,3.36,1.46.66.66,0,0,0-.33-.47c-.18-.08-.09,0-.22-.11l0,0-.13-.11c-.21-.13-.18,0-.26-.29l-.08,0,0,0c-.14,0-.09-.24-.22-.39s.06.11-.26-.05c-.17-.08,0,0-.09-.07s-.06,0-.13-.06l-.11,0c-.5-.2-.41-.28-.41-.79-.43-.11-.17-.44-.14-.72,0-.44-.21-.5-.11-1-.59,0-.35-.59-.52-1.23l0-.59c0-.12,0,0,.07-.17l-.16-.08c-.57-.34-.45-.6-.62-.71l-.42.13c-.13.09,0,.06-.19.11-.4-.37-.22-1.16-.35-1.65,0-.22-.1-.51-.38-.58a.91.91,0,0,1,.18-.37c-.15-.07-.22-.05-.36-.12a1.73,1.73,0,0,0-.19-1c-.11-.2,0-.21-.3-.24-.07.28-.05.11-.31.24a1.67,1.67,0,0,1-.22.93s0,0,0,0l0,.07a1.24,1.24,0,0,0-.25.6h.18c0,.27,0,.11-.14.28s-.07,0,0,.3-.21.34-.19.68.1.15.09.36-.06.18,0,.35c0,.45.18.34,0,.77s-.13.89-.41,1.35a5.2,5.2,0,0,0-.31.65.86.86,0,0,1-.69.27,3.19,3.19,0,0,1-.62-.3c-.11-.06-.2-.1-.25-.21s0-.08-.08-.18c-.14-.3-.54-.28-.83-.39s-.39-.51-1.08-.79l-.37-.11-.29-.2-.23-.26-.28-.2-.26-.16c-.24-.13-.21,0-.22-.34.14,0,.29-.29.4-.45s0,0,.08-.11l0-.13,0,0c0-.09.09-.22.12-.3-.25-.1,0,0-.24-.06.1-.14.07-.06.13-.24.31-.15.23-.06.42,0,.36-.54.15-.2.23-.51s.25-.32.37-.52l-.22-.14c-.25-.13-.2.1-.2-.34a1.1,1.1,0,0,0-.49.36c-.06-.08-.06.12-.06-.18a1,1,0,0,1-.3.12c.18-.23.09,0,.18-.24-.41.1-.56.1-.79.3-.15-.11-.24-.1-.3-.3-.31,0-.08,0-.36.12a1.74,1.74,0,0,0-.49-.25v-.11c-.32,0-.54.2-.81-.11a3,3,0,0,1-.16-.26c-.23.07-.13.07-.31.18,0-.14-.07-.21-.27-.34s0,0-.12,0L60,373s.09,0-.18.05v.19c.23.05,0,0,.17.07l0,0s0,0,0,0c.18.08.2,0,.48,0a1.3,1.3,0,0,1,.12.55l-.45.15,0,0-.55.06c-.23,0-.15,0-.24-.23l-.16.08-.15.09c-.18.13.09.05-.2.16a.53.53,0,0,1-.28,0c0,.16,0,.15-.13.34s0,.18-.3.21c0,.44.05.19.13.48l-.2.07c-.3.07-.16.07-.27.37s-.26.09-.38.65c.19.14.24.14.27.26a.44.44,0,0,1,0,.22c-.58,0-.32,0-.53,0a2.06,2.06,0,0,0-.68-.11c0,.44,0,.14-.13.26l0,0-.09.15c0-.42.09-.13.11-.48-.51-.15-.49-.69-1-.78s0-.12-.44-.13c-.11.22,0,.27-.24.42.06-.29,0-.09,0-.18-.23,0-.14.06-.31.18,0-.28-.07-.23-.3-.12,0,.18,0,.13.18.18a.73.73,0,0,0-.13.36l-.35-.3c-.16.31,0,.21-.24.37l-.08.05a1.77,1.77,0,0,0-.17.12c.09.33.16.07.06.31-.21,0-.22.09-.37.27,0,0,0,0,0,0l0,0-.1.09c-.09.08-.19.12-.22.3a.51.51,0,0,0,.15.35c-.13.16-.11.11-.12.37l-.27-.09c-.28-.07-.13.15-.21-.09h-.31c0,.41-.15.31-.06.49s.22.15.37.35c-.16.07-.06.05-.25,0,0,.32.08.11,0,.43-.18-.13-.09-.1-.3-.49s-.22-.13-.19-.54c-.25.07-.23.19-.35.36l-.3.31a1.09,1.09,0,0,0-.24.48c0,.18.11.28.11.6,0,0,0,0,0,0l.16,0c0,.13,0,.07-.09.16l-.06.06-.09.09-.1.08,0,0-.07.05c-.15.13-.12.14-.19.3l0,.08c-.37,1-.59,1-1.67,1.37-.21.07,0,.05-.23.07s-.16-.15-.41,0,0,.14-.24.31-.35-.1-.92.48a.5.5,0,0,1-.37.15c-.31,0-.08-.18-.48.09,0-.32.06-.12-.12-.19,0,.19,0,.16-.2.28-.37.28-.08-.08-.6.5l-.06.06-.19.23-.06.08c-.28.32-.9.18-.9,1.15h-.18a5.35,5.35,0,0,1-.06-.66,1.4,1.4,0,0,0-.43,1.08c.2.07.06-.1.16.15a.82.82,0,0,1,0,.75,1,1,0,0,0-.12.33V388c0,.15.06.1.2.27s0,.22.31.53l0,0,.15.21c.24.32.34.16.34.88H44a1,1,0,0,0-.66-.8c0,.56.15.19.18.61-.14-.09-.06-.07-.24-.12,0,.31.06.11-.12.18.39.59,1,.81,1.16,1.57.06.33.42.51.54.8s0,0,.1.19.12.11.19.18a.85.85,0,0,1,.2.53c.21,1.28,1,1.54,1.06,2.31v.45c0,.27,0,.22.1.49a.88.88,0,0,1-.09.56,1.84,1.84,0,0,1-.36-.05c0,.43,0,.83.38.82s.69.63,1.53.48a3.14,3.14,0,0,0,.92-.11c.24-.14.27-.29.36-.38l0,0,.09-.1,0-.06.18-.11c.14,0,.36,0,.43-.21,0,0,0-.1,0-.12.08-.33.57-.33.88-.43l.7-.1h.14c.22,0-.06,0,.16,0l.09,0a0,0,0,0,1,0,0c.22.1-.16,0,.23.08,0-.14.12-.21.51-.2s.7.19.9-.63a.53.53,0,0,1,.11-.31c.16-.18.25-.1.49-.24,1-.56.59-.66,1.69-.68a3.26,3.26,0,0,0,1.16-.35c.71-.29.64-.49,1.75-.49a3.08,3.08,0,0,0,.7-.1c.26,0,.8.38,1,.52.35-.09.16-.25.59,0,.26.16.44.1.74.17.08.19,0,0,0,.31.2-.05.2-.08.37,0,0,.13-.12.08-.15.22l.12.35c.15.13.27,0,.42.18s.1.26.32.54a1,1,0,0,1,.2.58h-.09l-.15.16c.36,0,.27.27.6.35.11,0,0,0,.12,0s0,0,.13.06l-.05-.24c0-.19,0-.24.36-.66s.64-.29.81-.6a1.68,1.68,0,0,1,.27-.45c.15-.16,0,.06.13-.17l0,0,0,.07a.53.53,0,0,1,.1.14c-.18,0-.15,0-.24.12.13.27.13.24,0,.41a1.42,1.42,0,0,0-.3.95c0,.35-.08.27-.42.27-.06.23-.1.17-.13.43a1.51,1.51,0,0,0,.43-.12c.26-.07.29.14.43-.18l.24-.73.12.18a.11.11,0,0,1,0,.05l0,.08,0,0c.34.69-.23.71-.26,1.11a2.07,2.07,0,0,0,.61-.12s0,0,0,0,0,0,0,0c.37.32.77.73.6,1.28v.34c0,.18.17.27.26.39l.25.4c.18.21.46.12.67.36l.17.2c.18-.07.18-.14.37-.08l.13.05.06,0c.16,0,.08,0,.23.07a2.65,2.65,0,0,1,.67.48c.34,0,1-.86,1.15-.24.3,0,.31-.22.55-.24l0,.08c-.08.18-.05-.11-.08.22l.28.26.09.09.19.07a.53.53,0,0,1,.11.25.31.31,0,0,0,.18-.43c.71,0,.91-.71,1.67-.68.49,0,.88.16,1.23-.12l.13-.17c.09-.21,0-.27,0-.45l.33-.88a1.21,1.21,0,0,1,.64-.79c.18-.15,0,0,.06-.16v0l0-.16a1.23,1.23,0,0,1,.33-.58c.35-.29.2-.5.74-1.07l.35-.2a.05.05,0,0,1,0,0l.12-.09C77.56,395.44,77.48,395,77.4,394.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.69,380.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.87,384.38a4.91,4.91,0,0,0-.61-.6,9.43,9.43,0,0,0-.94-.61,1.58,1.58,0,0,0-.47-.18.75.75,0,0,0-.3,0,2.13,2.13,0,0,1,.51-.57,1.87,1.87,0,0,0,.67-.9l.3-1.06h0l-.47.28c-.29.17-.6.33-.88.51a2.63,2.63,0,0,0-.74.71,1.06,1.06,0,0,0-.14.74c0,.17-.08.18-.08.18a1.13,1.13,0,0,0-.54.32c-.22.18-.44.37-.65.57a.52.52,0,0,0-.16.32,1,1,0,0,1-.25.55,2.9,2.9,0,0,0-.54,1.15c0,.14,0,.2.19.17a.44.44,0,0,0,.49.19s.06,0,.07,0c.32.15.46.12.76-.16a2.2,2.2,0,0,0,.2-.23c.15-.22.39-.24.61-.3a1.78,1.78,0,0,0,.74-.3s.17-.14.25,0a2.07,2.07,0,0,1,.29.39,1.65,1.65,0,0,1,.14.58,3.42,3.42,0,0,0,.22,1.1,1.19,1.19,0,0,0,1.38.74,2.22,2.22,0,0,1,1.2,0l.24.1-.46,0a.15.15,0,0,0-.15.1c-.21.5-.41,1-.65,1.49-.16.31-.39.59-.58.89s-.28.39-.14.6a1.05,1.05,0,0,0,.83.59l.62,0a1,1,0,0,0,.72-.53.35.35,0,0,0-.09-.34c-.06.16-.18.18-.32.2a.64.64,0,0,0-.2.08c0-.13.13-.13.25-.17l0-.26-.07,0c-.13.18-.2.2-.41.14l-.16-.05c-.18-.06-.21,0-.23.14a.66.66,0,0,1,0,.13.37.37,0,0,1,0-.47,8,8,0,0,1,.71-.83,9.35,9.35,0,0,0,1.42-1.89,1.14,1.14,0,0,0,.13-.35.69.69,0,0,0-.33-.72,5.73,5.73,0,0,0-.86-.51.6.6,0,0,1-.37-.71l.08.23c.07.21.27.28.44.37s.56.27.83.42a.84.84,0,0,1,.27,1.35l-.44.7c0,.09,0,.14.08.17.49.09,1,.22,1.46.28a7.88,7.88,0,0,0,1.19,0,13.64,13.64,0,0,0,2.18-.46,3.44,3.44,0,0,1,1.28-.08.12.12,0,0,0,.08,0c0-.23-.05-.46-.07-.68l-.06-.57a4.57,4.57,0,0,0-.44-1.85c-.06-.1-.13-.18-.2-.29a1.26,1.26,0,0,1,.42.37,2.33,2.33,0,0,1,.34.92c.11.56.18,1.12.27,1.68a6.38,6.38,0,0,0,.51,1.75,3.12,3.12,0,0,0,1.14,1.3,18.85,18.85,0,0,0,1.71.93c.48.24,1,.45,1.48.66s1.25.47,1.87.71l.91.32a.57.57,0,0,1,.36.35l-.5-.25,0,0c0,.18.11.35.15.53.09.47.18.94.26,1.41s.12.74.17,1.11c0,.2,0,.41,0,.61a1.3,1.3,0,0,0,.28.85,1.71,1.71,0,0,0,.2.18,6.58,6.58,0,0,1,1,1.3,1.09,1.09,0,0,0,.37.34H81s0-.07,0-.09a.34.34,0,0,1,0-.46,2.26,2.26,0,0,0,.13-.33c0-.2-.1-.34-.19-.49l-.12-.15-.25.32h0a.58.58,0,0,0,.09-.65,1.07,1.07,0,0,0-.4-.55,1,1,0,0,1-.48-.82c-.07-.42-.1-.85-.15-1.27a4.73,4.73,0,0,1-.05-.75c0-.36.07-.71.1-1.07a.78.78,0,0,0-.22-.58,4.73,4.73,0,0,0-1-.74c-.62-.43-1.25-.86-1.85-1.34a8.53,8.53,0,0,1-2-2.32,2.66,2.66,0,0,1-.34-1,1.68,1.68,0,0,1,.11-.86,3.72,3.72,0,0,0,.21,1.51c.32-.08.62-.21.67-.57a2.3,2.3,0,0,0,0-.64c0-.2.07-.32.27-.28a1,1,0,0,1,.62.48c.5.74,1,1.5,1.46,2.25.3.46.58.92.89,1.37.41.6.83,1.2,1.26,1.78a9.46,9.46,0,0,0,.77.89q.36.39.75.75a8.51,8.51,0,0,0,1.63,1.23,8.72,8.72,0,0,0,2.32,1,14.57,14.57,0,0,0,1.74.38,8.69,8.69,0,0,0,1.45.09,10.12,10.12,0,0,0,1.54-.19,8.52,8.52,0,0,0,2.29-.79c.35-.17.68-.4,1-.61a.17.17,0,0,0,.06-.06,2,2,0,0,0,0-.24c-.06,0-.14,0-.19,0s-.36.15-.54.23a11.38,11.38,0,0,1-2,.71,10.49,10.49,0,0,1-1.36.25,9.38,9.38,0,0,1-1.5,0,6.1,6.1,0,0,1-2.57-.74,7.49,7.49,0,0,1-1.74-1.2l-.58-.55a13,13,0,0,1-1.37-1.67A26.68,26.68,0,0,1,79.93,390l-1-1.79a18.27,18.27,0,0,0-1.58-2.48,11.16,11.16,0,0,0-1.24-1.33,7.22,7.22,0,0,0-3.45-1.66,11.09,11.09,0,0,0-1.27-.18c-.73,0-1.46-.07-2.19,0a11.8,11.8,0,0,0-3.12.43,8.08,8.08,0,0,0-1.82.89,4.38,4.38,0,0,1-1.23.55,2,2,0,0,1-.34,0,5.78,5.78,0,0,0-.72,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.5,374.79H141v1.38h-.29v-1.38h-.49v-.29h1.27Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.29,374.5v1.67H143V375l-.55.85-.55-.85v1.18h-.28V374.5h.31l.52.81.53-.81Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.48,378.83v.54a3.53,3.53,0,0,0-.94-.51,3.4,3.4,0,0,0-1.24-.2,3.75,3.75,0,0,0-1.43.27,3.61,3.61,0,0,0-1.14.76,3.49,3.49,0,0,0-.75,1.13,3.66,3.66,0,0,0,0,2.76,3.6,3.6,0,0,0,.75,1.13,3.43,3.43,0,0,0,1.14.75,3.58,3.58,0,0,0,1.43.28h.15a3.89,3.89,0,0,0,1.45-.27v-1.91h0a2.08,2.08,0,0,1-.67.43,2.19,2.19,0,0,1-.77.14,1.69,1.69,0,0,1-.33,0h0a2.37,2.37,0,0,1-.46-.11,1.93,1.93,0,0,1-.66-.43,1.82,1.82,0,0,1-.59-1.36,1.85,1.85,0,0,1,.59-1.37,2,2,0,0,1,.66-.41,2.09,2.09,0,0,1,.79-.15,2.05,2.05,0,0,1,1.44.56,1.82,1.82,0,0,1,.59,1.37v3.54h1.7v-6.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.29,385.74l-3.76-3.63v3.63h-1.7v-9.57h1.7v3.62l3.76-3.61H92.7l-5,4.77,5,4.79Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.6,378.66a3.22,3.22,0,0,1,1.26.24,3,3,0,0,1,1,.69,3,3,0,0,1,.62,1,3.41,3.41,0,0,1,.22,1.24v3.9H105v-3.9a1.41,1.41,0,0,0-.49-1.11,1.72,1.72,0,0,0-2.34,0,1.46,1.46,0,0,0-.48,1.11v3.9H100v-6.9h1.7v.52a3.37,3.37,0,0,1,.86-.51A2.85,2.85,0,0,1,103.6,378.66Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.62,378.84a3.17,3.17,0,0,1,1.14-.2v1.62a2,2,0,0,0-1.44.56,1.86,1.86,0,0,0-.6,1.37v3.55H124v-6.91h1.7v.53A4,4,0,0,1,126.62,378.84Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.6,378.66a3.91,3.91,0,0,1,1.46.27,4,4,0,0,1,1.19.76,3.47,3.47,0,0,1,.8,1.13,3.43,3.43,0,0,1,0,2.76,3.58,3.58,0,0,1-.8,1.13,3.9,3.9,0,0,1-2.65,1,3.9,3.9,0,0,1-2.64-1,3.58,3.58,0,0,1-.8-1.13,3.43,3.43,0,0,1,0-2.76,3.47,3.47,0,0,1,.8-1.13,3.78,3.78,0,0,1,2.64-1Zm0,1.61a2.05,2.05,0,0,0-1.44.56,1.82,1.82,0,0,0-.59,1.37,1.78,1.78,0,0,0,.59,1.36,1.93,1.93,0,0,0,.66.43,2.29,2.29,0,0,0,.78.14,2.21,2.21,0,0,0,.78-.14,2.08,2.08,0,0,0,.67-.43,1.82,1.82,0,0,0,.59-1.36,1.85,1.85,0,0,0-.59-1.37A2.13,2.13,0,0,0,131.6,380.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.55,378.66a3.91,3.91,0,0,1,1.46.27,4,4,0,0,1,1.19.76,3.47,3.47,0,0,1,.8,1.13,3.43,3.43,0,0,1,0,2.76,3.58,3.58,0,0,1-.8,1.13,3.93,3.93,0,0,1-4.11.75,3.6,3.6,0,0,1-2-1.88,3.43,3.43,0,0,1,0-2.76,3.47,3.47,0,0,1,.8-1.13,3.8,3.8,0,0,1,1.18-.76A4,4,0,0,1,139.55,378.66Zm0,1.61a2,2,0,0,0-1.44.56,1.83,1.83,0,0,0-.6,1.37,1.79,1.79,0,0,0,.6,1.36,1.93,1.93,0,0,0,.66.43,2.29,2.29,0,0,0,.78.14,2.25,2.25,0,0,0,.78-.14,2.08,2.08,0,0,0,.67-.43,1.82,1.82,0,0,0,.59-1.36,1.85,1.85,0,0,0-.59-1.37A2.13,2.13,0,0,0,139.55,380.27Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.39,378.83v.54a3.6,3.6,0,0,0-1-.51,3.38,3.38,0,0,0-1.23-.2,3.77,3.77,0,0,0-1.44.27,3.61,3.61,0,0,0-1.14.76,3.49,3.49,0,0,0-.75,1.13,3.66,3.66,0,0,0,0,2.76,3.6,3.6,0,0,0,.75,1.13,3.43,3.43,0,0,0,1.14.75,3.59,3.59,0,0,0,1.44.28h.14a3.89,3.89,0,0,0,1.45-.27v-1.91h0a2.14,2.14,0,0,1-.66.43,2.29,2.29,0,0,1-.78.14l-.33,0h0a2.37,2.37,0,0,1-.46-.11,1.93,1.93,0,0,1-.66-.43,1.82,1.82,0,0,1-.59-1.36,1.85,1.85,0,0,1,.59-1.37,2,2,0,0,1,.66-.41,2.09,2.09,0,0,1,.79-.15,2,2,0,0,1,1.44.56,1.83,1.83,0,0,1,.6,1.37v3.54h1.7v-6.91Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.15,378.83h0v.53a3.53,3.53,0,0,0-.94-.51,3.74,3.74,0,0,0-.62-.16,4.23,4.23,0,0,0-.73-.06,3.45,3.45,0,0,0-1.41.28,3.19,3.19,0,0,0-1.1.76,3.41,3.41,0,0,0-.72,1.13,3.72,3.72,0,0,0-.25,1.38h0a3.54,3.54,0,0,0,.27,1.38,3.6,3.6,0,0,0,.75,1.13,3.43,3.43,0,0,0,1.14.75,3.54,3.54,0,0,0,1.43.28h.25a4,4,0,0,0,1.35-.27v-1.91h0a2.08,2.08,0,0,1-.67.43,2.19,2.19,0,0,1-.77.14,1.69,1.69,0,0,1-.33,0h0a2.37,2.37,0,0,1-.46-.11,1.93,1.93,0,0,1-.66-.43,1.82,1.82,0,0,1-.59-1.36,1.89,1.89,0,0,1,.14-.72l0-.05a1.9,1.9,0,0,1,.43-.6,2,2,0,0,1,.66-.41,2.09,2.09,0,0,1,.79-.15,2.05,2.05,0,0,1,1.44.56,1.9,1.9,0,0,1,.43.6l0,.05a1.78,1.78,0,0,1,.14.72v2.69a1.8,1.8,0,0,1-.59,1.36,2.07,2.07,0,0,1-2.46.31l-1.24,1.16a3.84,3.84,0,0,0,1,.53,3.83,3.83,0,0,0,3.85-.86,3.47,3.47,0,0,0,.8-1.13,3.33,3.33,0,0,0,.29-1.37v-6.05h-1.7Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.8,391.58V392h-2v-2.58h1.9v.46H85.34v.65H86.5V391H85.34v.57Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.06,389.25V392h-.51v-.12A1.12,1.12,0,0,1,89,392a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1.09,1.09,0,0,1,.58.15v-.89Zm-.51,2.16v-.8a.76.76,0,0,0-.48-.17.58.58,0,0,0-.6.57.57.57,0,0,0,.6.57A.76.76,0,0,0,89.55,391.41Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.3,390v2h-.51v-.13a1,1,0,0,1-.54.16c-.58,0-.84-.27-.84-.92V390h.5v1.09c0,.31.15.46.44.46a.64.64,0,0,0,.44-.16V390Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.42,391.64a1,1,0,0,1-.76.4,1,1,0,1,1,0-2.05,1,1,0,0,1,.77.39l-.33.31a.52.52,0,0,0-.44-.24.58.58,0,0,0-.59.56.59.59,0,0,0,.59.57.52.52,0,0,0,.44-.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.67,390v2h-.5v-.15a1,1,0,0,1-.58.18,1,1,0,0,1,0-2.05,1.18,1.18,0,0,1,.58.16V390Zm-.5.59a.75.75,0,0,0-.49-.17.57.57,0,1,0,0,1.13.75.75,0,0,0,.49-.17Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.66,390.45v.7c0,.35.06.45.32.45l.23,0V392a1.13,1.13,0,0,1-.46.08.58.58,0,0,1-.6-.63v-1h-.28V390h.28v-.77h.51V390h.56v.42Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.43,389.54a.29.29,0,1,1,.29.3A.29.29,0,0,1,103.43,389.54Zm0,.52h.5v2h-.5Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.43,391a1.09,1.09,0,0,1-2.17,0,1.09,1.09,0,0,1,2.17,0Zm-.5,0a.59.59,0,0,0-1.17,0,.59.59,0,0,0,1.17,0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.58,390.93V392h-.5v-1.11c0-.31-.15-.45-.43-.45a.63.63,0,0,0-.44.15V392h-.51v-2h.51v.12a1,1,0,0,1,.53-.16C110.32,390,110.58,390.29,110.58,390.93Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.56,389.92v.91h1.23v.45h-1.23V392h-.5v-2.58H116v.46Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.27,391a1.09,1.09,0,1,1-1.08-1A1.05,1.05,0,0,1,119.27,391Zm-.5,0a.57.57,0,0,0-.58-.56.58.58,0,0,0-.59.56.59.59,0,0,0,.59.57A.58.58,0,0,0,118.77,391Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.42,390v2h-.51v-.13a1,1,0,0,1-.54.16c-.58,0-.84-.27-.84-.92V390h.5v1.09c0,.31.15.46.43.46a.65.65,0,0,0,.45-.16V390Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.67,390.93V392h-.5v-1.11c0-.31-.15-.45-.43-.45a.63.63,0,0,0-.44.15V392h-.51v-2h.51v.12a.92.92,0,0,1,.53-.16C125.41,390,125.67,390.29,125.67,390.93Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129,389.25V392h-.51v-.12a1.12,1.12,0,0,1-.58.16,1,1,0,0,1-1-1,1,1,0,0,1,1-1,1.09,1.09,0,0,1,.58.15v-.89Zm-.51,2.16v-.8a.76.76,0,0,0-.48-.17.57.57,0,0,0-.59.57.56.56,0,0,0,.59.57A.76.76,0,0,0,128.51,391.41Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.38,390v2h-.51v-.15a1,1,0,0,1-.58.18,1,1,0,0,1,0-2.05,1.15,1.15,0,0,1,.58.16V390Zm-.51.59a.73.73,0,0,0-.49-.17.57.57,0,1,0,0,1.13.71.71,0,0,0,.49-.17Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.37,390.45v.7c0,.35,0,.45.31.45l.23,0V392a1.08,1.08,0,0,1-.46.08.57.57,0,0,1-.59-.63v-1h-.29V390h.29v-.77h.51V390h.55v.42Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.13,389.54a.29.29,0,1,1,.29.3A.29.29,0,0,1,136.13,389.54Zm0,.52h.51v2h-.51Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.13,391a1.09,1.09,0,1,1-1.08-1A1.06,1.06,0,0,1,140.13,391Zm-.5,0a.57.57,0,0,0-.58-.56.58.58,0,0,0-.59.56.59.59,0,0,0,.59.57A.58.58,0,0,0,139.63,391Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.29,390.93V392h-.51v-1.11c0-.31-.15-.45-.43-.45a.65.65,0,0,0-.44.15V392h-.5v-2h.5v.12a1,1,0,0,1,.53-.16C143,390,143.29,390.29,143.29,390.93Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.81,396.56V397h-2v-2.58h1.9v.46H95.34v.65h1.17V396H95.34v.58Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.16,394.25V397h-.51v-.12a1.12,1.12,0,0,1-.58.16,1,1,0,0,1,0-2.06,1.19,1.19,0,0,1,.58.15v-.89Zm-.51,2.16v-.79a.71.71,0,0,0-.49-.17.56.56,0,0,0-.59.57.56.56,0,0,0,.59.57A.74.74,0,0,0,98.65,396.41Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.5,395v2H101v-.13a1,1,0,0,1-.54.16c-.58,0-.85-.27-.85-.91V395h.51v1.1c0,.31.15.46.43.46a.69.69,0,0,0,.45-.16V395Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.72,396.64a.94.94,0,0,1-.77.4,1,1,0,1,1,0-2.05,1,1,0,0,1,.78.4l-.33.3a.54.54,0,0,0-.45-.24.58.58,0,0,0-.59.57.59.59,0,0,0,.59.57.55.55,0,0,0,.45-.25Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.06,395v2h-.5v-.14a1.07,1.07,0,0,1-.59.17,1,1,0,0,1,0-2.05,1.18,1.18,0,0,1,.59.16V395Zm-.5.59a.75.75,0,0,0-.49-.17.56.56,0,0,0-.59.57.57.57,0,0,0,.59.57.81.81,0,0,0,.49-.17Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.15,395.45v.7c0,.36,0,.46.31.46l.23,0V397a1.18,1.18,0,0,1-.46.07.57.57,0,0,1-.6-.62v-1h-.28V395h.28v-.78h.52V395h.55v.42Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108,394.51a.3.3,0,0,1,.29-.3.29.29,0,0,1,.29.3.29.29,0,0,1-.29.3A.29.29,0,0,1,108,394.51Zm0,.52h.51v2H108Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.1,396a1.09,1.09,0,1,1-1.09-1A1.05,1.05,0,0,1,111.1,396Zm-.5,0a.59.59,0,1,0-.59.57A.58.58,0,0,0,110.6,396Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.35,395.91V397h-.51v-1.1c0-.31-.15-.46-.43-.46a.66.66,0,0,0-.44.16V397h-.51v-2H112v.12a1,1,0,0,1,.53-.16C113.09,395,113.35,395.26,113.35,395.91Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.19,395.87a4.92,4.92,0,0,1-.39.59l.31.3-.31.28-.28-.28a1.11,1.11,0,0,1-.69.28c-.59,0-1-.27-1-.75a.78.78,0,0,1,.54-.69.69.69,0,0,1-.23-.5.68.68,0,0,1,.73-.7.67.67,0,0,1,.73.65.8.8,0,0,1-.55.71l.44.42a3.45,3.45,0,0,0,.3-.43Zm-.94.61-.58-.57q-.3.13-.3.36c0,.2.17.36.48.36A.64.64,0,0,0,116.25,396.48Zm-.65-1.36c0,.19.16.3.22.37s.39-.17.39-.38a.31.31,0,0,0-.31-.34A.33.33,0,0,0,115.6,395.12Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.6,394.43h.57L120,397h-.25l-1.2-2.58h.57l.75,1.69Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.4,394.51a.29.29,0,1,1,.58,0,.29.29,0,1,1-.58,0Zm0,.52H122v2h-.51Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.5,396.48a1.69,1.69,0,0,0,.68.16c.24,0,.33-.09.33-.19s-.11-.17-.42-.23-.74-.24-.74-.62.3-.61.76-.61a1.91,1.91,0,0,1,.77.16l-.17.37a1.89,1.89,0,0,0-.61-.12c-.2,0-.3.07-.3.17s.12.16.44.23.73.26.73.62-.29.62-.8.62a1.7,1.7,0,0,1-.86-.19Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.32,395v2h-.5v-.14a1.07,1.07,0,0,1-.59.17,1,1,0,0,1,0-2.05,1.18,1.18,0,0,1,.59.16V395Zm-.5.59a.75.75,0,0,0-.49-.17.56.56,0,0,0-.59.57.57.57,0,0,0,.59.57.81.81,0,0,0,.49-.17Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130,396.26c0,.49-.4.79-1,.79a1.94,1.94,0,0,1-1.07-.25l.19-.4a1.88,1.88,0,0,0,.9.19c.28,0,.45-.1.45-.29s-.17-.25-.55-.34c-.53-.12-1-.27-1-.78s.36-.78,1-.78a2.51,2.51,0,0,1,1,.21l-.21.42a2.43,2.43,0,0,0-.79-.17c-.26,0-.41.12-.41.28s.18.26.57.34C129.57,395.61,130,395.78,130,396.26Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.74,396.16a.55.55,0,0,0,.57.45.63.63,0,0,0,.51-.25l.32.27a1.07,1.07,0,0,1-.89.41,1,1,0,0,1,0-2.05,1,1,0,0,1,1,1.06v.11Zm0-.32h1a.44.44,0,0,0-.48-.44A.52.52,0,0,0,130.74,395.84Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.09,395.31a.74.74,0,0,1,.63-.32l.12,0v.55l-.25,0a.48.48,0,0,0-.5.52V397h-.51v-2h.51Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.15,395l-1,2H135l-1-2h.54l.54,1.12.54-1.12Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.41,394.51a.29.29,0,1,1,.58,0,.29.29,0,1,1-.58,0Zm0,.52H137v2h-.51Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.19,396.64a.94.94,0,0,1-.77.4,1,1,0,1,1,0-2.05,1,1,0,0,1,.78.4l-.33.3a.53.53,0,0,0-.45-.24.57.57,0,0,0-.58.57.58.58,0,0,0,.58.57.54.54,0,0,0,.45-.25Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.9,396.16a.56.56,0,0,0,.57.45.63.63,0,0,0,.51-.25l.33.27a1.09,1.09,0,0,1-.9.41,1,1,0,0,1,0-2.05,1,1,0,0,1,1,1.06s0,.08,0,.11Zm0-.32h1a.44.44,0,0,0-.48-.44A.5.5,0,0,0,139.91,395.84Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.82,396.48a1.69,1.69,0,0,0,.68.16c.24,0,.33-.09.33-.19s-.12-.17-.42-.23-.74-.24-.74-.62.29-.61.76-.61a1.91,1.91,0,0,1,.77.16l-.17.37a1.9,1.9,0,0,0-.62-.12c-.19,0-.29.07-.29.17s.12.16.44.23.73.26.73.62-.29.62-.8.62a1.67,1.67,0,0,1-.86-.19Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 138.99,
    x2: 300.77,
    y2: 138.99
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 425.32,
    x2: 300.77,
    y2: 425.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 396.69,
    x2: 300.77,
    y2: 396.69
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 368.06,
    x2: 300.77,
    y2: 368.06
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 339.42,
    x2: 300.77,
    y2: 339.42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 310.79,
    x2: 300.77,
    y2: 310.79
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 282.16,
    x2: 300.77,
    y2: 282.16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 253.53,
    x2: 300.77,
    y2: 253.53
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 224.89,
    x2: 300.77,
    y2: 224.89
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 196.26,
    x2: 300.77,
    y2: 196.26
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 167.63,
    x2: 300.77,
    y2: 167.63
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 411.01,
    x2: 300.77,
    y2: 411.01
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 382.37,
    x2: 300.77,
    y2: 382.37
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 353.74,
    x2: 300.77,
    y2: 353.74
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 325.11,
    x2: 300.77,
    y2: 325.11
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 296.47,
    x2: 300.77,
    y2: 296.47
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 267.84,
    x2: 300.77,
    y2: 267.84
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 239.21,
    x2: 300.77,
    y2: 239.21
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 210.58,
    x2: 300.77,
    y2: 210.58
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 181.94,
    x2: 300.77,
    y2: 181.94
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 153.31,
    x2: 300.77,
    y2: 153.31
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 0.12,
    x2: 0.13,
    y2: 425.32
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.45,
    y1: 0.12,
    x2: 286.45,
    y2: 425.32
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 28.76,
    y1: 0.12,
    x2: 28.76,
    y2: 425.32
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 57.39,
    y1: 0.12,
    x2: 57.39,
    y2: 425.32
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 86.02,
    y1: 0.12,
    x2: 86.02,
    y2: 425.32
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 114.66,
    y1: 0.12,
    x2: 114.66,
    y2: 425.32
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 143.29,
    y1: 0.12,
    x2: 143.29,
    y2: 425.32
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 171.92,
    y1: 0.12,
    x2: 171.92,
    y2: 425.32
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 200.55,
    y1: 0.12,
    x2: 200.55,
    y2: 425.32
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 229.19,
    y1: 0.12,
    x2: 229.19,
    y2: 425.32
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 257.82,
    y1: 0.12,
    x2: 257.82,
    y2: 425.32
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 14.44,
    y1: 0.12,
    x2: 14.44,
    y2: 425.32
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 43.07,
    y1: 0.12,
    x2: 43.07,
    y2: 425.32
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 71.71,
    y1: 0.12,
    x2: 71.71,
    y2: 425.32
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.34,
    y1: 0.12,
    x2: 100.34,
    y2: 425.32
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 128.97,
    y1: 0.12,
    x2: 128.97,
    y2: 425.32
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 157.61,
    y1: 0.12,
    x2: 157.61,
    y2: 425.32
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 186.24,
    y1: 0.12,
    x2: 186.24,
    y2: 425.32
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 214.87,
    y1: 0.12,
    x2: 214.87,
    y2: 425.32
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 243.5,
    y1: 0.12,
    x2: 243.5,
    y2: 425.32
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 272.14,
    y1: 0.12,
    x2: 272.14,
    y2: 425.32
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 300.77,
    y1: 0.12,
    x2: 300.77,
    y2: 425.32
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 110.36,
    x2: 300.77,
    y2: 110.36
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 81.73,
    x2: 300.77,
    y2: 81.73
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 53.1,
    x2: 300.77,
    y2: 53.1
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 24.46,
    x2: 300.77,
    y2: 24.46
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 124.68,
    x2: 300.77,
    y2: 124.68
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 96.04,
    x2: 300.77,
    y2: 96.04
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 67.41,
    x2: 300.77,
    y2: 67.41
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 38.78,
    x2: 300.77,
    y2: 38.78
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.13,
    y1: 10.15,
    x2: 300.77,
    y2: 10.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.13,
    y: 0.13,
    width: 300.64,
    height: 425.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(0.12 442.19)"
  }, "Size: A4 (21cm x 2", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 61.86,
    y: 0
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 66.25,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 67.49,
    y: 0
  }, "7cm)"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial11);
export default __webpack_public_path__ + "static/media/guideMaterial11.76c8d52f0d659457629da2c405e1e3e8.svg";
export { ForwardRef as ReactComponent };